import React from 'react';
import { FadeIn } from './FadeIn';
export const CTASection: React.FC = () => {
  return <section className="w-full" data-id="element-88">
      {/* Cinematic image — the documentary's closing frame */}
      <div className="relative w-full h-[55vh] min-h-[360px] sm:h-[65vh] sm:min-h-[480px]" data-id="element-89">
        <img src="https://cdn.magicpatterns.com/uploads/5XR4dztptm7orqG7tDTt8N/imagen_8.png" alt="Man on rooftop looking at city skyline at sunset" className="absolute inset-0 w-full h-full object-cover" data-id="element-90" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/30 via-navy/40 to-navy/60" data-id="element-91" />
        <div className="absolute inset-0 flex items-center justify-center px-5" data-id="element-92">
          <FadeIn data-id="element-93">
            <h2 className="text-3xl sm:text-5xl md:text-6xl font-serif font-bold text-white text-center drop-shadow-lg leading-[1.15] tracking-tight max-w-3xl" data-id="element-94">
              The noise stops. The man remains.
            </h2>
          </FadeIn>
        </div>
      </div>

      {/* Editorial closing section */}
      <div className="w-full bg-cream pt-20 sm:pt-28 md:pt-32 pb-12 sm:pb-16" data-id="element-95">
        <div className="max-w-[680px] mx-auto px-6 sm:px-8 text-center" data-id="element-96">
          <FadeIn data-id="element-97">
            <p className="text-[11px] sm:text-xs font-sans font-medium tracking-[0.25em] uppercase text-navy/40 mb-8 sm:mb-10" data-id="element-98">
              One Final Thought
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-99">
            <h2 className="font-serif text-2xl sm:text-3xl md:text-[2.5rem] leading-[1.3] sm:leading-[1.25] tracking-tight text-navy mb-10 sm:mb-14" data-id="element-100">
              Most men spend years blaming themselves
              <span className="block text-navy/60 mt-3 sm:mt-4 text-xl sm:text-2xl md:text-[1.75rem] leading-[1.4] italic font-normal" data-id="element-101">
                without realizing their brain was trapped in a cycle designed to
                keep them overstimulated, distracted, and emotionally exhausted.
              </span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-102">
            <div className="space-y-6 sm:space-y-7 font-serif text-[1.0625rem] sm:text-[1.1875rem] leading-[1.75] sm:leading-[1.8] text-navy/80 mb-14 sm:mb-16 max-w-[560px] mx-auto" data-id="element-103">
              <p data-id="element-104">
                UNHOOKED helps you finally understand what's really happening —
                and how to regain control without shame, streak counting, or
                constant internal battles.
              </p>
              <p data-id="element-105">
                Don't spend another year feeling controlled by something you no
                longer even enjoy.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-106">
            <div className="flex flex-col items-center" data-id="element-107">
              <a href="https://unhooked.vitalyforms.com" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 bg-navy text-cream font-sans text-sm sm:text-[15px] font-medium tracking-wide px-8 sm:px-10 py-4 sm:py-[18px] rounded-full transition-all duration-300 hover:bg-navy-light hover:shadow-[0_12px_40px_-12px_rgba(15,20,25,0.5)] hover:-translate-y-0.5 shadow-[0_4px_20px_-6px_rgba(15,20,25,0.25)]" data-id="element-108">
                <span data-id="element-109">Start Reading UNHOOKED</span>
                <span className="inline-block transition-transform duration-300 group-hover:translate-x-1" data-id="element-110">
                  →
                </span>
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};